require('dotenv').config();
// const Cryptr = require('../commons/crypter/cryptr').default;
const Encryption = require('../../encryption');

const encrypter_c = new Encryption(process.env.REACT_APP_ENCRYPT_C_SECRET,
  {
    pbkdf2Iterations: parseInt(process.env.REACT_APP_ENCRYPT_ITERATIONS),
    saltString: process.env.REACT_APP_ENCRYPT_SALT
  });

const encrypter_s = new Encryption(process.env.REACT_APP_ENCRYPT_S_SECRET,
  {
    pbkdf2Iterations: parseInt(process.env.REACT_APP_ENCRYPT_ITERATIONS),
    saltString: process.env.REACT_APP_ENCRYPT_SALT
  });

const encrypter_att_c = new Encryption(process.env.REACT_APP_ENCRYPT_C_ATT_SECRET,
  {
    pbkdf2Iterations: parseInt(process.env.REACT_APP_ENCRYPT_ITERATIONS_ATT),
    saltString: process.env.REACT_APP_ENCRYPT_SALT_ATT
  });

const crypter_c = () => { return encrypter_c }
const crypter_s = () => { return encrypter_s }
const crypter_att_c = () => { return encrypter_att_c }

export {
  crypter_c,
  crypter_s,
  crypter_att_c,
}